import React from 'react';
import FiscalStatusBadge from './FiscalStatusBadge';
import { Button } from '../ui';

type Check = {
  key: string;
  label: string;
  ok: boolean;
  critical?: boolean;
};

type Readiness = {
  status?: string;
  completed?: number;
  total?: number;
  checks?: Check[];
};

export const FiscalReadiness: React.FC<{
  data?: Readiness | null;
  loading?: boolean;
  onRun?: () => void;
}> = ({ data, loading, onRun }) => {
  return (
    <div className="space-y-4">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h3 className="text-lg font-semibold text-slate-900">Diagnóstico fiscal</h3>
          <p className="text-sm text-slate-500">
            Estado: {data?.completed ?? 0}/{data?.total ?? 0} configuraciones completadas
          </p>
        </div>
        <div className="flex items-center gap-2">
          <FiscalStatusBadge status={data?.status} />
          <Button type="button" variant="outline" size="sm" onClick={onRun} loading={loading}>
            Ejecutar diagnóstico
          </Button>
        </div>
      </div>

      <ul className="divide-y divide-slate-100 rounded-2xl border border-slate-200 bg-white">
        {(data?.checks || []).map((c) => (
          <li key={c.key} className="flex items-center justify-between gap-3 px-4 py-3">
            <div>
              <p className="text-sm font-medium text-slate-800">{c.label}</p>
              {c.critical && !c.ok && (
                <p className="text-xs text-rose-600">Crítico para emitir e-CF</p>
              )}
            </div>
            <span
              className={`inline-flex h-7 w-7 items-center justify-center rounded-full text-xs font-bold ${
                c.ok ? 'bg-emerald-100 text-emerald-700' : 'bg-rose-100 text-rose-700'
              }`}
            >
              {c.ok ? '✓' : '!'}
            </span>
          </li>
        ))}
        {!data?.checks?.length && !loading && (
          <li className="px-4 py-8 text-center text-sm text-slate-500">
            Ejecute el diagnóstico para ver el estado fiscal.
          </li>
        )}
      </ul>
    </div>
  );
};

export default FiscalReadiness;
